import PlayScene from "./scenes/PlayScene";
import TitleScene from "./scenes/TitleScene";
import TutorialScene from "./scenes/TutorialScene";

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [TitleScene, TutorialScene, PlayScene],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: TitleScene.KEY,
    // startScene: PlayScene.KEY,

    initScene: 'TitleScene',
		isWidescreen: false,
		currentScene: null,
		gameOver: false,
		mute: false,
		gamePaused: false,
		startPaused: false,
		preSS: "preloader",
		ss: "UIAssets",
		audio: "gameAudio",
		allowMouse: true,
		enableMouse: true,
		backgroundColor: "#B8FFD5",
		scaling: 1.0,
		advancedTiming: true,
		showDebugAll: false,

		rightAnswer: false,
		levels: 5,
		currentLevel: 1,
		questions: 7,
		nounType: "",
		wrongAnswers: [],
		gatorLocs: [{x:684, y:325},
                    {x:84, y:335},
                    {x:504, y:500},
                    {x:84, y:650},
                    {x:694, y:720},
                    {x:234, y:850}],
		score: 0,
		time: 60, //in seconds
		correctAnswers: 0,
		incorrectAnswers: 0
}
